import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Module7.css";

const Module7 = () => {
  return (
    <div>
    <div className="hero-section position-relative">
      {/* Imagem Desktop */}
      <img
        src="/criada.png"
        alt="Quem sou eu"
        className="hero-img hero-img-desktop"
      />

      {/* Imagem Mobile */}
      <img
        src="/marino2.jpg"
        alt="Quem sou eu"
        className="hero-img hero-img-mobile"
      />

      <div className="hero-overlay p-5">
        <h2
          className="fw-bold"
          style={{ letterSpacing: "8px", lineHeight: "22.0px" }}
        >
          QUEM É O<span style={{ color: "#ECA600" }}> {""}MARINO?</span>
        </h2>
        <img
          src="/marino2.jpg"
          alt="Minha foto"
          className="hero-img-portrait d-block d-md-none mt-4"
        />
        <p className="mt-4 fs-6 text-black">
          Com mais de <strong>20 anos de experiência</strong> no mercado
          financeiro, minha trajetória sempre foi guiada pela busca por{" "}
          <strong>investimentos sólidos e estratégias inteligentes</strong>.
          Desde cedo, entendi que a independência financeira não acontece por
          acaso – ela é fruto de planejamento, boas decisões e acesso às
          oportunidades certas.
        </p>

        <p className="mt-4 fs-6 text-black">
          <strong>
            Acredito que negócios são a única forma real de mudar de patamar
            financeiro.
          </strong>{" "}
          Poupar dinheiro ou investir na bolsa pode ser válido, mas o que
          realmente acelera a evolução patrimonial é{" "}
          <strong>ter acesso às melhores oportunidades de negócios</strong>. Por
          isso, me dedico a estruturar investimentos estratégicos que{" "}
          <strong>impulsionam o crescimento dos investidores</strong>.
        </p>

        <p className="mt-4 fs-6 text-black">
          Há <strong>três anos estou na Europa</strong>, estudando profundamente
          o mercado imobiliário e construindo uma{" "}
          <strong>rede estratégica de contatos</strong> que inclui investidores,
          fornecedores, corretores, consultores e especialistas do setor. Meu
          objetivo sempre foi compreender cada detalhe desse mercado para criar
          um modelo de investimento que realmente funcione para quem busca{" "}
          <strong>rentabilidade, segurança e previsibilidade</strong>.
        </p>

        <p className="mt-4 fs-6 text-black">
          <strong>Foi com esse propósito que criei a IMO Investimentos</strong>,
          uma plataforma que conecta investidores a{" "}
          <strong>projetos imobiliários de alta rentabilidade na Europa</strong>
          . Tenho ao meu lado{" "}
          <strong>
            consultores de engenharia, arquitetura e marketing/vendas
          </strong>
          , garantindo que cada projeto seja{" "}
          <strong>
            planejado, executado e comercializado da forma mais eficiente
            possível
          </strong>
          .
        </p>
        
      </div>
      
    </div>




    </div>

    
  );
};

export default Module7;
